module.exports = "/static/Images/en/Five.png";